import { Box, IconButton, Stack, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import DeleteIcon from '@mui/icons-material/Delete';
import { recordButtonStyles, recordingBoxStyles, stopRecordingButtonStyles, wavesContainerStyles } from './styles';
import { useTranslation } from 'react-i18next';

interface AudioRecorderProps {
  isRecording: boolean;
  recordingTime: number;
  formatTime: (seconds: number) => string;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onDeleteRecording: () => void;
}

export const AudioRecorder = ({
  isRecording,
  recordingTime,
  formatTime,
  onStartRecording,
  onStopRecording,
  onDeleteRecording,
}: AudioRecorderProps) => {
  const { t } = useTranslation();
  if (!isRecording) {
    return (
      <Stack gap={1} alignItems="flex-start">
        <Typography variant="subtitle2">{t('callsMenu.selectedStage.audioRecorder.title')}</Typography>
        <IconButton aria-label="grabar audio" sx={recordButtonStyles} onClick={onStartRecording}>
          <MicIcon fontSize="medium" />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Stack gap={2}>
      <Typography variant="subtitle2">{t('callsMenu.selectedStage.audioRecorder.title')}</Typography>
      <Box sx={recordingBoxStyles}>
        <IconButton
          aria-label={t('callsMenu.selectedStage.audioRecorder.delete')}
          sx={{ color: (theme) => theme.palette.action.disabled }}
          onClick={() => {
            onStopRecording();
            onDeleteRecording();
          }}
        >
          <DeleteIcon />
        </IconButton>

        <Typography variant="body2" color="text.primary" sx={{ minWidth: 50 }}>
          {formatTime(recordingTime)}
        </Typography>

        <Box sx={wavesContainerStyles}>
          {[...Array(20)].map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 3,
                height: `${Math.random() * 25 + 5}px`,
                backgroundColor: (theme) => theme.palette.primary.main,
                mx: 0.5,
                borderRadius: 1,
                animation: 'pulse 0.5s infinite alternate',
                '@keyframes pulse': {
                  '0%': {
                    height: `${Math.random() * 15 + 5}px`,
                  },
                  '100%': {
                    height: `${Math.random() * 35 + 5}px`,
                  },
                },
              }}
            />
          ))}
        </Box>

        <IconButton aria-label="detener grabación" sx={stopRecordingButtonStyles} onClick={onStopRecording}>
          <StopIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};
